import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import usePermission from 'hooks/usePermission';
import { MenuInfo } from 'data';
import Error403 from 'pages/Error403';

function RootRedirect() {
    const { authenticated } = useSelector(
        state => state.authToken
    );

    const monitoring = MenuInfo.CMMS;

    const {
        hasPermission,
        isPermissionReady
    } = usePermission();

    // 로그인하지 않은 상태
    if (!authenticated) {
        return <Navigate to="/auth/login" replace />;
    }

    // 로그인은 했지만 사용자 정보/권한 조회 중
    if (!isPermissionReady) {
        return null;
    }

    const monitoringVisible =
        (!monitoring.permission ||
            hasPermission(monitoring.permission)) &&
        (monitoring.feature === undefined ||
            monitoring.feature);

    if (!monitoringVisible) {
        return <Error403 />;
    }

    const visibleMenus = monitoring.children.filter(menu => {
        const permissionOk =
            !menu.permission ||
            hasPermission(menu.permission);

        const featureOk =
            menu.feature === undefined ||
            menu.feature;

        return permissionOk && featureOk;
    });

    if (!visibleMenus.length) {
        return <Error403 />;
    }

    return (
        <Navigate
            to={visibleMenus[0].path}
            replace
        />
    );
}

export default RootRedirect;